<template>
  <Modal :active="active" @close="handleCancel">
    <div
      class=""
      id="staticBackdrop4"
      data-mdb-backdrop="static"
      data-mdb-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
    >
      <div class="modal-dialog-centered model-width1">
        <div class="">
          <div class="d-flex justify-content-center align-items-center border-bottom py-4 gap-3 px-2">
            <div class="d-flex justify-content-center align-items-center">
              <h2 class="text-center">
                {{ title }}
                <span v-if="title === 'Deposit' || title === 'Withdraw'" :style="'font-size: 2rem; font-weight: 400;'" class="ms-2">
                  (
                  {{
                    title === "Deposit"
                      ? computedTotal || "0.00"
                      : withdrawTotalETHAmount || "0.00"
                  }}
                  )
                </span>
              </h2>
            </div>
            <div class="d-flex">
              <a  v-if="title === 'Deposit'"  @click="handleOk" class="btn btn-black d-block w-100 ms-2">{{
                btnOk
              }}</a>
            </div>
          </div>
          <div
            class="modal-body pt-0 mt-3"
            :style="'max-height: 700px; overflow-x: auto;'"
          >
            <div
              v-for="(field, index) in fields"
              :key="field.name"
              class="form mb-3 text-left"
            >
              <label class="mb-2">
                {{ field.label }}
              </label>
              <!-- @blur="handleFieldBlur(index)" -->
              <textarea
                v-if="field.type == 'textarea'"
                v-model="field.model"
                class="form-control"
                :ref="`field-${index}`"
                @focus="handleFieldFocus(index)"
              ></textarea>
              <input
                v-else
                v-model="field.model"
                type="text"
                class="form-control"
                :placeholder="field.placeholder || ''"
                :ref="`field-${index}`"
                @input="onChange($event, index)"
              />
            </div>
            <div
              v-if="title === 'Deposit'"
              class="d-flex justify-content-between align-content-center mt-2 gap-2"
            >
              <div>
                <label class="form-label"
                  >From<img class="ms-lg-2 pointer" src="img/info-card.svg"
                /></label>
                <input
                  style="margin-top: 0px; width:70px"
                  type="text"
                  v-model="from"
                  class="form-control"
                  placeholder=""
                />
              </div>
              <div>
                <label class="form-label"
                  >To<img class="ms-lg-2 pointer" src="img/info-card.svg"
                /></label>
                <input
                  style="margin-top: 0px; width:70px"
                  type="text"
                  v-model="to"
                  class="form-control"
                  placeholder=""
                />
              </div>
              <div>
                <label class="form-label"
                  >Amount<img class="ms-lg-2 pointer" src="img/info-card.svg"
                /></label>
                <input
                  style="margin-top: 0px; width:70px"
                  type="text"
                  v-model="amount"
                  class="form-control"
                  placeholder=""
                />
              </div>
            </div>
            <div
              class="d-flex justify-content-center flex-wrap align-content-center mt-2"
            >
              <a
                v-if="title === 'Deposit'"
                @click="handleSiphonDeposit"
                class="btn d-block w-100"
                style="
                  background-color: blue;
                  color: white;
                  font-size: medium;
                  font-weight: 800;
                "
                data-mdb-dismiss="modal"
                >Siphon Deposit</a
              >
            </div>
            <div
              class="d-flex justify-content-between flex-wrap align-content-center mt-2"
            >
              <div class="col-xl-6 col-6 text-center">
                <a
                  @click="handleCancel"
                  class="btn btn-outline-black d-block me-2"
                  data-mdb-dismiss="modal"
                  >{{ btnCancel }}</a
                >
              </div>
              <div class="col-xl-6 col-6 d-flex text-center">
                <a @click="handleOk" class="btn btn-black d-block w-100 ms-2">{{
                  btnOk
                }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from "vuex";
import Modal from "./Modal.vue";
import Web3 from "@/helpers/Web3";
export default {
  name: "InputModal",
  props: {
    callback: {},
    active: {
      type: Boolean,
    },
    fields: {
      type: Array,
    },
    hasCopy: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    withdrawTotalETHAmount: {
      type: String,
      default: "0.00",
    },
    btnCancel: {
      type: String,
      default: "No",
    },
    btnOk: {
      type: String,
      default: "Yes",
    },
  },
  components: {
    Modal,
  },
  computed: {
    ...mapGetters({}),
    computedTotal() {
      const total = this.fields.reduce((sum, field) => {
        const amount = parseFloat(field.model) || 0;
        return sum + amount;
      }, 0);
      return total.toFixed(2); // Format as "0.00"
    },
  },
  watch: {
    active(newVal) {
      if (newVal && this.title === "Deposit") {
        this.from = 1;
        this.to = this.fields.length;
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeyDown);
  },
  async mounted() {
    this.from = 1;
    this.to = this.fields.length;
    window.addEventListener("keydown", this.handleKeyDown);
  },
  methods: {
    onChange (event, index) {
      const selectedObject = this.fields[index];
      selectedObject.model.trim().split(" ").map((newValue, st) =>{
        const curObject = this.fields[index+st];
        curObject.model = newValue;  
      });
    },
    handleCancel() {
      this.$emit("cancel");
    },
    handleFieldFocus(index) {
      this.focusedFieldIndex = index;
      // console.log(`Field ${index} is focused`);
    },
    // handleFieldBlur(index) {
    //   // Optional: handle blur event
    //   // console.log(`Field ${index} lost focus`);
    // },
    getFocusedFieldIndex() {
      return this.focusedFieldIndex;
    },
    getLevel() {
      return Web3.getLevel();
    },
    handleOk() {
      if (this.callback) {
        this.callback();
      } else {
        this.$emit("ok");
      }
    },
    handleSiphonDeposit() {
      // Convert from and to to numbers and ensure they're valid
      const fromIndex = parseInt(this.from) - 1;
      const toIndex = parseInt(this.to) - 1;

      // Validate indexes
      if (
        fromIndex < 0 ||
        fromIndex >= this.fields.length ||
        toIndex < 0 ||
        toIndex >= this.fields.length ||
        fromIndex > toIndex
      ) {
        this.$toast.error("Invalid range selected");
        return;
      }

      for (let i = 0; i < this.fields.length; i++) {
        this.fields[i].model = "0";
      }
      // Set values for the selected range
      for (let i = fromIndex; i <= toIndex; i++) {
        this.fields[i].model = this.amount.toString();
      }
      // if(this.callback) {
      //   this.callback();
      // } else {
      //   this.$emit("ok");
      // }
    },
    // async copyClipboard() {
    //   const text = await navigator.clipboard.readText();
    //   const addresses = text.match(/(\b0x[a-fA-F0-9]{40}\b)/g);
    //   for (let i = 0; i < this.fields.length; i++) {
    //     this.fields[i].model = addresses[i];
    //   }
    //   // console.log(this.fields, addresses);
    // },
    // async copyClipboard(fromIndex) {
    //   if(this.title !== 'Deposit') return;
    //   for (let i = 0; i < this.fields.length; i++) {
    //     this.fields[i].model = '0';
    //   }
    //   const text = await navigator.clipboard.readText();
    //   console.log('Clipboard Text: ', text);
    //   const values = text.split(/[\s,]+/).filter(addr => addr.length > 0);
    //   console.log('Parsed Values: ', values);
    //   const lengthOfValues = values.length;
    //   for (let i = fromIndex; i < Math.min(fromIndex + lengthOfValues , this.fields.length) ; i++) {
    //     this.fields[i].model = values[i - fromIndex];
    //   }
    //   // console.log(this.fields, addresses);
    // },
    async copyClipboard() {
      const text = await navigator.clipboard.readText();
      const addresses = text.match(/(\b0x[a-fA-F0-9]{40}\b)/g)
      for (let i = 0; i < this.fields.length; i++) {
        this.fields[i].model = addresses[i];
      }
      console.log(this.fields, addresses)
    },
    //Key Actions

    // handleKeyDown(event) {
    //   /*
    //   if(event.key >= '0' && event.key <= '9' && event.code.startsWith('Digit'))
    //     this.txConfig.selectCount = Number(event.key) === 0 ? 10 : Number(event.key);
    //   */
    //   // if(event.code === this.lastKeyCode && this.getActiveAccounts().length <= 10) {
    //   //   switch(event.code) {
    //   //   case "KeyB":
    //   //     this.handleBuy(undefined, undefined, undefined);
    //   //     break;
    //   //   case "KeyS":
    //   //     this.handleSell();
    //   //     break;
    //   //   case "KeyF":
    //   //     this.handleFixed();
    //   //     break;
    //   //   case "KeyG":
    //   //     this.handleMixed();
    //   //     break;
    //   //   }
    //   //   this.lastKeyCode = '';
    //   // }
    //   // else {

    //   // }

    //   // Handle Ctrl+V to paste clipboard text
    //   if (event.ctrlKey && event.key === "v") {
    //     let fromIndex = this.getFocusedFieldIndex();
    //     console.log('Current Focused FromIndex : ' , fromIndex);
    //     if(fromIndex === -1) { fromIndex = 0; }
    //     this.copyClipboard(fromIndex);
    //     return;
    //   }
    //   // switch (event.code) {
    //   //   case "KeyD":
    //   //     this.toggleSelectAll(false);
    //   //     break;
    //   // }
    //   // this.lastKeyCode = event.code;
    // },
  },
  data() {
    return {
      from: 1,
      to: 1,
      amount: 0.05,
      focusedFieldIndex: -1, // -1 means no field is focused
    };
  },
};
</script>

<style scoped></style>
